export const twitterLinks = [
  { name: 'IBRAHIM', url: 'https://twitter.com/kingibro345' },
  { name: 'FELIX', url: 'https://twitter.com/monzo200' },
  {
    name: 'ELI',
    url: 'https://www.linkedin.com/in/ely-cheikh-maaloum-075a79135/',
  },
  { name: 'KENNEDY', url: 'https://twitter.com/_iamkobby' },
];

export const linkedinLinks = [
  { name: 'KENNEDY', url: 'www.linkedin.com/in/kennedy-owusu' },
  {
    name: 'ELI',
    url: 'https://www.linkedin.com/in/ely-cheikh-maaloum-075a79135/',
  },
  { name: 'FELIX', url: 'https://www.linkedin.com/in/felixnyamai/' },
  { name: 'IBRAHIM', url: 'https://www.linkedin.com/dmambo' },
];

export const githubLinks = [
  { name: 'KENNEDY', url: 'https://github.com/kennedyowusu' },
  { name: 'ELI', url: 'https://github.com/maaloum' },
  { name: 'FELIX', url: 'https://github.com/felixDev22' },
  { name: 'IBRAHIM', url: 'https://github.com/dmambo' },
];

export const webLinks = [
  { name: 'KENNEDY', url: 'https://dmambo.github.io/portfolio-web/' },
  { name: 'ELI', url: 'https://maaloum.netlify.app/' },
  {
    name: 'FELIX',
    url: 'https://deploy-preview-19--felix-portfolio-7f7ed5.netlify.app/',
  },
  { name: 'IBRAHIM', url: 'https://dmambo.github.io/portfolio-web/' },
];
